import React from 'react';
import Produccion from '../../components/produccion/A_Produccion';
import { PageWrapper } from '../../components/common';

const A_Produccion: React.FC = () => {
  return (
    <PageWrapper>
      <Produccion />
    </PageWrapper>
  );
};

export default A_Produccion;